/* eslint-disable-next-line import/no-relative-packages */
import { Locale } from '../../../config';
import ErrorSVG from '../assets/svgs/error.svg';
import NotFoundSVG from '../assets/svgs/not-found.svg';
import { ErrorType, Error } from '../types/errors';

const loadErrorEn = {
  image: ErrorSVG,
  title: 'Something went wrong',
  body: 'Sorry for the inconvenience.\nIf this error persists, it might be that your network is blocking parts of the application.\nIf you are connected to a company network, please contact your IT department to check this, otherwise please try again at home or using a different device.',
};

const notFoundErrorEn = {
  image: NotFoundSVG,
  title: 'Not found!',
  body: 'The page or resource you are looking for does not exist.',
  button: {
    text: 'Back to the dashboard',
    url: '/home',
  },
};

const genericErrorEn = {
  image: ErrorSVG,
  title: 'Something went wrong',
  body: 'Sorry for the inconvenience. Our technical staff is already on it!',
  button: {
    text: 'Logout',
    url: '/logout',
  },
};

export const errors: Record<ErrorType, Record<Locale, Error>> = {
  [ErrorType.LOAD]: {
    [Locale.DE_DE]: {
      image: ErrorSVG,
      title: 'Etwas ist schiefgelaufen',
      body: 'Wir entschuldigen uns für die Unannehmlichkeiten.\nFalls dieser Fehler weiterhin auftritt, könnte es sein, dass dein Netzwerk Teile der Anwendung blockiert.\nFalls du mit einem Firmennetzwerk verbunden bist, kontaktiere bitte dein IT-Department um dies zu überprüfen - weiterhin könntest du eine erneute Verbindung von Zuhause aus oder mit einem anderen Gerät probieren.',
    },
    [Locale.EN_DE]: loadErrorEn,
    [Locale.EN_GB]: loadErrorEn,
    [Locale.EN_CA]: loadErrorEn,
  },
  [ErrorType.NOT_FOUND]: {
    [Locale.DE_DE]: {
      image: NotFoundSVG,
      title: 'Nicht gefunden!',
      body: 'Die Seite oder der Inhalt den du suchst, existiert nicht.',
      button: {
        text: 'Zurück zum Dashboard',
        url: '/home',
      },
    },
    [Locale.EN_DE]: notFoundErrorEn,
    [Locale.EN_GB]: notFoundErrorEn,
    [Locale.EN_CA]: notFoundErrorEn,
  },
  [ErrorType.GENERIC]: {
    [Locale.DE_DE]: {
      image: ErrorSVG,
      title: 'Etwas ist schiefgelaufen',
      body: 'Wir entschuldigen uns für die Unannehmlichkeiten. Unser Team kümmert sich um das Problem!',
      button: {
        text: 'Ausloggen',
        url: '/logout',
      },
    },
    [Locale.EN_DE]: genericErrorEn,
    [Locale.EN_GB]: genericErrorEn,
    [Locale.EN_CA]: genericErrorEn,
  },
};
